/** @jsxImportSource react */
import type { SVGProps } from 'react';
const WarningOutline = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      d="M12 8a.75.75 0 0 1 .75.75v4.5a.75.75 0 0 1-1.5 0v-4.5A.75.75 0 0 1 12 8M12 18a1 1 0 1 0 0-2 1 1 0 0 0 0 2"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M10.763 2.923c-.901.407-1.586 1.634-2.955 4.087l-3.824 6.851c-1.31 2.348-1.966 3.523-1.855 4.484a3 3 0 0 0 1.228 2.09c.785.566 2.13.566 4.819.566h7.647c2.69 0 4.034 0 4.82-.566a3 3 0 0 0 1.227-2.09c.11-.961-.545-2.136-1.855-4.484l-3.824-6.85c-1.37-2.454-2.054-3.68-2.955-4.088a3 3 0 0 0-2.473 0m7.942 11.67L14.88 7.74c-.7-1.252-1.174-2.1-1.58-2.694-.414-.603-.618-.728-.684-.757a1.5 1.5 0 0 0-1.236 0c-.065.03-.27.154-.682.757-.407.594-.882 1.442-1.581 2.694l-3.824 6.851c-.67 1.2-1.12 2.01-1.4 2.64-.281.635-.283.866-.275.94a1.5 1.5 0 0 0 .614 1.046c.061.044.264.155.956.218.686.063 1.613.065 2.987.065h7.647c1.374 0 2.301-.002 2.987-.065.692-.063.895-.174.956-.218a1.5 1.5 0 0 0 .614-1.045c.008-.075.006-.306-.276-.942-.28-.629-.73-1.439-1.4-2.639"
      clipRule="evenodd"
    />
  </svg>
);
export default WarningOutline;
